import { User } from '../../auth/model/user';
import { Injectable, OnDestroy } from '@angular/core';
import { AbortError, HttpClient, HttpError, HttpRequest, HttpResponse, TimeoutError } from '@microsoft/signalr';
import { StorageService } from '../storage/storage.service';
import { AuthFacade } from '../../stores/auth/facades/auth.facade';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalRHttpClient extends HttpClient implements OnDestroy {
  private subscription: Subscription = new Subscription();
  private currentUser: User;

  public constructor(
    private storage: StorageService,
    private authFacade: AuthFacade
  ) {
    super();
    this.subscription.add(this.authFacade.getUser$.subscribe(x => this.currentUser = x));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public send(request: HttpRequest): Promise<HttpResponse> {
    if (request.abortSignal && request.abortSignal.aborted) {
      return Promise.reject(new AbortError());
    }

    if (!request.method) {
      return Promise.reject(new Error('No method defined.'));
    }
    if (!request.url) {
      return Promise.reject(new Error('No url defined.'));
    }

    return new Promise<HttpResponse>((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open(request.method!, request.url!, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');


      const headers = request.headers;
      if (headers) {
        Object.keys(headers)
          .forEach((header) => {
            xhr.setRequestHeader(header, headers[header]);
          });
      }
      xhr.setRequestHeader('accept-language', this.currentUser.language);

      if (request.responseType) {
        xhr.responseType = request.responseType;
      }

      if (request.abortSignal) {
        request.abortSignal.onabort = () => {
          xhr.abort();
          reject(new AbortError());
        };
      }

      if (request.timeout) {
        xhr.timeout = request.timeout;
      }

      xhr.onload = () => {
        if (request.abortSignal) {
          request.abortSignal.onabort = null;
        }

        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(new HttpResponse(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
        }else {
          reject(xhr);
        }
      };

      xhr.onerror = () => {
        reject(new HttpError(xhr.statusText, xhr.status));
      };

      xhr.ontimeout = () => {
        reject(new TimeoutError());
      };

      xhr.send(request.content || '');
    });
  }

}
